'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

const EmptyGames: React.FC<{ text?: string }> = ({ text }) => {
  const t = useTranslations('translation')

  return (
    <div className={styles.container}>{text ? text : t('noGamesFound')}</div>
  )
}

export default EmptyGames
